var resolve = {
    topLeft: 'position-top-left',
    topRight: 'position-top-right',
    topCenter: 'position-top-center',
    bottomRight: 'position-bottom-right',
    bottomLeft: 'position-bottom-left',
    bottomCenter: 'position-bottom-center'
};
export function resolvePosition(position) {
    return resolve[position];
}
